"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDocumentType = void 0;
exports.OrderDocumentType = {
    CUSTOMER_BOL: 'CUSTOMER_BOL',
    PALLET_LABELS: 'PALLET_LABELS',
    DELIVERY_ORDER: 'DELIVERY_ORDER',
    PACKING_LIST: 'PACKING_LIST'
};
//# sourceMappingURL=order-document-type.js.map